import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import StickyMobileCtaBar from '@/components/StickyMobileCtaBar';

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);

  return (
    <div className="island-app bg-background text-foreground">
      <Header />
      <main className="island-main pb-24 sm:pb-0">
        <Outlet />
      </main>
      <Footer />
      <StickyMobileCtaBar />
    </div>
  );
}
